import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
  PAYOFF_CALLABILITY_AMOUNT,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const AUTOCALL_GROWTH_AT_MATURITY_SETTINGS = {
  id: ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY,
  label: 'Autocallable (Growth at Maturity)',
  effects: [
    {
      formControlNames: [
        PAYOFF_COUPON_REFERENCE_RATE,
        PAYOFF_PARTICIPATION_BASE,
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_CONVERSION,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
      ],
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
        PAYOFF_COUPON_FREQUENCY,
      ],
      readOnly: false,
    },
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      selectValues: [COUPON_TYPE.FIXED],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_TYPE],
      selectValues: ['CALL'],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['AUTOCALL'],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT_TYPE],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: ['NONE'],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
  ],
};
